module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-line2-a106f92bdfa841ca32a29170bcaa3cea.svg";